/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { ReturnToMobileBanner as ReturnToMobileBannerType } from './ReturnToMobileBanner.tsx';

const LazyReturnToMobileBanner = lazy<typeof ReturnToMobileBannerType>(
	() =>
		import(
			/* webpackChunkName: "async-return-to-mobile-banner" */ './ReturnToMobileBanner.tsx'
		).then(({ ReturnToMobileBanner }) => ReturnToMobileBanner),
	{
		ssr: true,
		entryFsSsrLiftImportToModule: true,
		// eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
		includeInShellOnlySsrBundle: true,
	},
);

export const ReturnToMobileBanner = (): React.JSX.Element => (
	<Placeholder name="async-return-to-mobile-banner" fallback={null}>
		<LazyReturnToMobileBanner />
	</Placeholder>
);
